// check url and open tab
if (window.location.pathname === "/member/profile") {
  if (window.location.hash === "#profile") {
    setTabProfile("#profile_nav", "#profile_content");
  } else if (window.location.hash === "#invoices") {
    setTabProfile("#invoices_nav", "#invoices_content");
  } else if (window.location.hash === "#uploads") {
    setTabProfile("#savings_nav", "#licenses_content");
  } else if (window.location.hash === "#licenses") {
    setTabProfile("#licenses_nav", "#licenses_content");
  }
}
function setTabProfile(navId, contentId) {
  removeClassInElements(
    ".container_cabinet_content",
    "active_cabinet_content"
  );
  removeClassInElements(".nav_cabinet_item", "active_border_bottom");
  
  document.querySelector(navId) &&
  document
    .querySelector(navId)
    .classList.add("active_border_bottom");
  document.querySelector(contentId) &&
    document
      .querySelector(contentId)
      .classList.add("active_cabinet_content");
}

let idsNavContent = [
  {
    navId: "profile_nav",
    contentId: "profile_content",
  },
  {
    navId: "invoices_nav",
    contentId: "invoices_content",
  },
  {
    navId: "savings_nav",
    contentId: "savings_content",
  },
  {
    navId: "licenses_nav",
    contentId: "licenses_content",
  },
];

for (let obj of idsNavContent) {
  document.querySelector("#" + obj.navId) &&
    document
      .querySelector("#" + obj.navId)
      .addEventListener("click", function () {
        removeClassInElements(
          ".container_cabinet_content",
          "active_cabinet_content"
        );
        removeClassInElements(".nav_cabinet_item", "active_border_bottom");
        document.querySelector("#" + obj.navId) &&
          document
            .querySelector("#" + obj.navId)
            .classList.add("active_border_bottom");
        document.querySelector("#" + obj.contentId) &&
          document
            .querySelector("#" + obj.contentId)
            .classList.add("active_cabinet_content");
      });
}

// VALIDATION INPUTS
let buttonEdit = document.getElementById("btn_edit");
buttonEdit &&
  document.getElementById("btn_edit").addEventListener("click", function () {
    let inputName = document.getElementById("profile_name_input");
    let inputEmail = document.getElementById("profile_email_input");
    let inputOS = document.getElementById("profile_OS_input");
    let inputCountry = document.getElementById("profile_country_input");
    let inputIndustry = document.getElementById("profile_industry_input");

    let inputNameMsg = document.getElementById("profile_name_msg");
    let inputEmailMsg = document.getElementById("profile_email_msg");
    if (!validateOnEmpty(inputName)) {
      inputNameMsg.classList.add("show_msg");
    } else {
      inputNameMsg.classList.remove("show_msg");
    }
    if (!validateEmail(inputEmail)) {
      inputEmailMsg.classList.add("show_msg");
      return;
    } else {
      inputEmailMsg.classList.remove("show_msg");
    }
    sentRequestEdit(
      inputName.value,
      inputEmail.value,
      inputOS.getAttribute("data-id"),
      inputCountry.getAttribute("data-id"),
      inputIndustry.getAttribute("data-id")
    );
  });

function sentRequestEdit(name, email, os, country, industry) {
  const request = new XMLHttpRequest();
  const url = "/member/profile/update";
  const params =
    "ChangeProfileForm[full_name]=" +
    name +
    "&ChangeProfileForm[email]=" +
    email +
    "&ChangeProfileForm[primary_os]=" +
    os +
    "&ChangeProfileForm[country]=" +
    country +
    "&ChangeProfileForm[following_industry]=" +
    industry +
    "&_csrf=" +
    jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) { 
      if(request.status === 200) {
        console.log("edit request response", request.responseText);
        let response = JSON.parse(request.responseText);
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (response.status === "ok") {
          showMsg("msg_for_edit", response.message);
        }
        if (response.status === "error") {
          let responseErrorsMsg = createErrorsMsg(response.errors);
          showMsg("msg_for_edit", responseErrorsMsg);
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

// SHOW/HIDE PASSWORD
let passInputs = document.querySelectorAll(".input_show_pass");
for (let item of passInputs) {
  item.querySelector(".icon_show_pass").addEventListener("click", function () {
    let elInput = item.querySelector("input");
    let typeInput =
      elInput.getAttribute("type") === "password" ? "text" : "password";
    elInput.setAttribute("type", typeInput);
  });
}

// CHANGE PASSWORD
let buttonChangePass = document.querySelector("#btn_change_pass");
buttonChangePass &&
  document
    .querySelector("#btn_change_pass")
    .addEventListener("click", function () {
      document.querySelector("#btn_change_pass").classList.add("hide");
      document.querySelector(".block_inputs_change_pass").classList.add("open");
    });

let confirmPassMsg = "confirmed password does not match new password!";
let btnConfirmNewPass = document.querySelector("#btn_confirm_new_pass");
btnConfirmNewPass &&
  document
    .querySelector("#btn_confirm_new_pass")
    .addEventListener("click", function () {
      let inputOldPass = document.getElementById("change_old_pass");
      let inputNewPass = document.getElementById("change_new_pass");
      let inputConfirmNewPass = document.getElementById(
        "change_confirm_new_pass"
      );

      let oldPassMsg = document.getElementById("change_old_pass_msg");
      let newPassMsg = document.getElementById("change_new_pass_msg");
      let confirmNewPassMsg = document.getElementById(
        "change_confirm_new_pass_msg"
      );
      if (!validateOnEmpty(inputOldPass)) {
        oldPassMsg.classList.add("show_msg");
      } else {
        oldPassMsg.classList.remove("show_msg");
      }
      if (!validateOnEmpty(inputNewPass)) {
        newPassMsg.classList.add("show_msg");
      } else {
        newPassMsg.classList.remove("show_msg");
      }
      if (!validateOnEmpty(inputConfirmNewPass)) {
        confirmNewPassMsg.classList.add("show_msg");
        return;
      } else {
        confirmNewPassMsg.classList.remove("show_msg");
      }

      if (inputNewPass.value !== inputConfirmNewPass.value) {
        showMsg("msg_for_change_pass", confirmPassMsg);
      } else {
        sentRequestChagnePass(
          inputOldPass.value,
          inputNewPass.value,
          inputConfirmNewPass.value
        );
      }
    });

let changePassMsgError = "your password has not changed! try again!";
function sentRequestChagnePass(oldPass, newPass, confirmNewPass) {
  const request = new XMLHttpRequest();
  const url = "/member/password/change";
  const params =
    "ChangePassword[password_old]=" +
    oldPass +
    "&ChangePassword[password]=" +
    newPass +
    "&ChangePassword[password_confirmation]=" +
    confirmNewPass +
    "&_csrf=" +
    jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("change request response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          showMsg("msg_for_change_pass", response.message);
          cleanPassInputs();
        }
        if (response.status === "error") {
          let responseErrorsMsg = createErrorsMsg(response.errors);
          showMsg("msg_for_change_pass", responseErrorsMsg);
          cleanPassInputs();
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

// clean value in inputs for change password 
function cleanPassInputs() {
  document.getElementById("change_old_pass").value = document.getElementById("change_new_pass").value = document.getElementById("change_confirm_new_pass").value = "";
}
// END CHANGE PASSWORD

// SELECT BTN IN SAVINGS CARD

for (let blockBtn of document.querySelectorAll(".block_savings_select_btn")) {
  blockBtn.addEventListener("click", function () {
    changeSelectBtn(this);
  });
}

function changeSelectBtn(el) {
  if (el.firstElementChild.classList.contains("btn_savings_select")) {
    changeBtnToSelected(el);
  } else {
    changeBtnToSelect(el);
  }
}

function changeBtnToSelected(el) {
  let elSelected = document.createElement("div");
  elSelected.className = "btn_savings_selected";
  elSelected.innerHTML = `
    <img
      class="arrow_ok"
      src="./images/cabinet/arrow_OK.png"
      alt=""
    />
    <div class="text">selected</div>`;
  el.replaceChild(elSelected, el.firstElementChild);
}
function changeBtnToSelect(el) {
  let elSelect = document.createElement("div");
  elSelect.className = "btn_savings_select";
  elSelect.innerHTML = `select`;
  el.replaceChild(elSelect, el.firstElementChild);
}
// END SELECT BTN IN SAVINGS CARD
// BTN SELECT/DISELECT ALL CARD
let btnSelectAllCard = document.querySelector("#select_all_card");
btnSelectAllCard &&
  document
    .querySelector("#select_all_card")
    .addEventListener("click", function () {
      if (this.classList.contains("selected_all")) {
        changeAllBtnsToSelect(this);
      } else {
        changeAllBtnsToSelected(this);
      }
    });

function changeAllBtnsToSelect(el) {
  for (let blockBtn of document.querySelectorAll(".block_savings_select_btn")) {
    changeBtnToSelect(blockBtn);
    el.classList.remove("selected_all");
    el.firstElementChild.innerText = "Select All";
  }
}
function changeAllBtnsToSelected(el) {
  for (let blockBtn of document.querySelectorAll(".block_savings_select_btn")) {
    changeBtnToSelected(blockBtn);
    el.classList.add("selected_all");
    el.firstElementChild.innerText = "Deselect All";
  }
}
// END BTN SELECT/DISELECT ALL CARD
// MODAL WINDOW FOR CHECKBOX PRIVACY
let checkboxPrivacy = document.querySelector(".savings_checkbox");
let modalWindow = document.getElementById("modalWindow");
let closeModalWindow = document.querySelector(".close_modal_profile");
let modalProfileText = document.querySelector(".block_modal_profile_text");
let modalProfileBtnOk = document.querySelector(".modal_profile_btn_ok");

closeModalWindow &&
  closeModalWindow.addEventListener("click", function () {
    modalWindow.style.display = "none";
    unlockScroll();
  });
let btnProfileModalCancel = document.querySelector(".modal_profile_btn_cancel");
btnProfileModalCancel &&
  btnProfileModalCancel.addEventListener("click", function () {
    modalWindow.style.display = "none";
    unlockScroll();

    modalProfileText.style.display = "block";
    document.querySelector(".modal_profile_btn_ok").style.display = "block";
    document.querySelector("#modal_window_msg").innerText = "";
    document.querySelector("#modal_window_msg").style.display = "none";
    btnProfileModalCancel.innerText = "cancel";
  });
window.addEventListener("click", function (event) {
  if (event.target == modalWindow) {
    modalWindow.style.display = "none";
    unlockScroll();

    modalProfileText.style.display = "block";
    document.querySelector(".modal_profile_btn_ok").style.display = "block";
    document.querySelector("#modal_window_msg").innerText = "";
    document.querySelector("#modal_window_msg").style.display = "none";
    btnProfileModalCancel.innerText = "cancel";
  }
});
closeModalESC(modalWindow);

checkboxPrivacy &&
  checkboxPrivacy.addEventListener("click", function () {
    if (this.classList.contains("active")) {
      console.log("active");
      contentDisagreePrivacy();
    } else {
      console.log("not active");
      contentAgreePrivacy();
    }
    modalWindow.style.display = "block";
    lockScroll();
  });
function contentAgreePrivacy() {
  delListenersFromBtn();
  let text = document.querySelector("#text_activate_privacy").innerText;
  modalProfileText.innerText = text.trim();
  document
    .querySelector(".modal_profile_btn_ok")
    .addEventListener("click", () => {
      requestSavingsCheckbox(checkboxPrivacy.getAttribute("data-url"), true);
    });
}
function activateCheckboxPrivacy() {
  checkboxPrivacy.querySelector("input").checked = true;
  checkboxPrivacy.classList.add("active");
  modalWindow.style.display = "none";
  unlockScroll();
}
function contentDisagreePrivacy() {
  delListenersFromBtn();
  let text = document.querySelector("#text_disagree_privacy").innerText;
  modalProfileText.innerText = text.trim();
  document
    .querySelector(".modal_profile_btn_ok")
    .addEventListener("click", () => {
      requestSavingsCheckbox(checkboxPrivacy.getAttribute("data-url"), false);
    });
}
function deactivateCheckboxPrivacy() {
  checkboxPrivacy.querySelector("input").checked = false;
  checkboxPrivacy.classList.remove("active");
  document.querySelector(".container_savings_cards") &&
    document.querySelector(".container_savings_cards").remove();
  modalWindow.style.display = "none";
  unlockScroll();
}
function requestSavingsCheckbox(urlRequest, agreement) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "agreement=" + agreement + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("savings checkbox response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          if (agreement) {
            activateCheckboxPrivacy();
          } else {
            deactivateCheckboxPrivacy();
          }
        }
        if (response.status === "error") {
          console.log("error savings checkbox response", request.responseText);
          return false;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
// END MODAL WINDOW FOR CHECKBOX PRIVACY
function delListenersFromBtn() {
  let oldElement = document.querySelector(".modal_profile_btn_ok");
  let newElement = oldElement.cloneNode(true);
  oldElement.parentNode.replaceChild(newElement, oldElement);
}
// MODAL WINDOW FOR DELETE SAVINGS-CARD
let btnDeleteCard = document.querySelector("#delete_card");

btnDeleteCard && btnDeleteCard.addEventListener("click", checkSelectCard);

function checkSelectCard() {
  if (document.querySelectorAll(".btn_savings_selected").length == 0) {
    delListenersFromBtn();
    console.log("no select card");
    let text = document.querySelector("#text_not_select_card").innerText;
    modalProfileText.innerText = text.trim();
    document
      .querySelector(".modal_profile_btn_ok")
      .addEventListener("click", closeDeleteModal);
  } else {
    delListenersFromBtn();
    console.log("select card");
    let text = document.querySelector("#text_selected_card").innerText;
    modalProfileText.innerText = text.trim();
    document
      .querySelector(".modal_profile_btn_ok")
      .addEventListener("click", deleteSelectedCard);
  }
  modalWindow.style.display = "block";
  lockScroll();
}
function closeDeleteModal() {
  modalWindow.style.display = "none";
  unlockScroll();
  modalProfileBtnOk.removeEventListener("click", closeDeleteModal);
}

function deleteSelectedCard() {
  let url = btnDeleteCard.getAttribute("data-url");
  let cardIds = getSelectedCards();
  requestDeleteCards(url, cardIds);
}
function getSelectedCards() {
  let selectedIds = [];
  for (let card of document.querySelectorAll(".item_savings_card")) {
    if (card.querySelector(".btn_savings_selected")) {
      selectedIds.push(card.getAttribute("data-card-id"));
    }
  }
  return selectedIds;
}
function requestDeleteCards(urlRequest, cardIds) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "deleteIDs=" + cardIds + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("delete cards response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          delCardsFromDOM();
          modalWindow.style.display = "none";
          unlockScroll();
        }
        if (response.status === "error") {
          console.log("error delete cards response", request.responseText);
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
function delCardsFromDOM() {
  for (let btnSelected of document.querySelectorAll(".btn_savings_selected")) {
    let card = btnSelected.closest(".item_savings_card");
    card.remove();
  }
  checkCardsCount();
}
function checkCardsCount() {
  if (document.querySelectorAll(".item_savings_card").length == 0) {
    document.querySelector(".block_no_cards").classList.add("active");
  }
}
// END MODAL WINDOW FOR DELETE SAVINGS-CARD

// MODAL WINDOW WITH EMAIL
let emailModalWindow = document.getElementById("modalEmailWindow");
let closeEmailModal = document.querySelector(".close_modal_email");
let modalEmailText = document.querySelector(".block_modal_email_text");
let inputEmail = document.querySelector("#email_modal_input");
let inputEmailMsg = document.querySelector("#email_modal_msg");
let inputKey = document.querySelector("#key_modal_input");
let inputKeyMsg = document.querySelector("#key_modal_msg");

let blockMsgEmailModal = document.querySelector("#msg_for_email_modal");

let btnCancelEmailModal = document.querySelector(".modal_email_btn_cancel");

let textForFindv4 = document.querySelector("#text_for_findmyv4");
let blockForFindv4 = document.querySelector("#block_for_findmyv4");
let textCheckInputs = document.querySelector("#text_check_inputs");

body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".btn_find_license");
  if (btnEl) {
    inputEmail.style.display = "block";
    inputEmail.value = "";
    inputKey.value = "";
    emailModalWindow.querySelector(".modal_email_btn_send").innerText = btnEl.getAttribute("data-name-btn");
    inputEmailMsg.classList.remove("show_msg");
    lockScroll();
    emailModalWindow.querySelector(".form_input.modal_email label").style.display = "block";
    modalEmailText.innerHTML = btnEl.getAttribute("data-text");
    blockForFindv4.style.display = "block";
    emailModalWindow.style.display = "block";
    let btnType = btnEl.getAttribute("data-type-btn");
    setListenerSend(btnType);
  }
})

// old transfer_btn listener 
// document.querySelector("#licenses_content") && document.querySelector("#licenses_content").addEventListener("click", (event) => {
//   let elEvent = event.target;
//   let btnEl = elEvent.closest(".transfer_btn");
//   if (btnEl) {
//     inputEmail.style.display = "block";
//     inputEmail.value = "";
//     inputKey.value = "";
//     inputEmailMsg.classList.remove("show_msg");
//     lockScroll();
//     blockForFindv4.style.display = "none";
//     emailModalWindow.querySelector(".form_input.modal_email label").style.display = "none";

//     // data atribute for btn
//     let dataKey = btnEl.getAttribute("data-key");
//     let dataBtnName = btnEl.closest(".block_license_card").querySelector(".text_transfer_license_permanently").getAttribute("data-name-btn");
//     let dataShowEmail = btnEl.closest(".block_license_card").querySelector(".text_transfer_license_permanently").getAttribute("data-show-email");

//     emailModalWindow.querySelector(".modal_email_btn_send").innerText = dataBtnName;
//     let btnType = "";
//     if (btnEl.classList.contains("simple_transfer_type")) {
//       btnType = "permanently";
//       if(btnEl.getAttribute("data-popup-text") !== null) {
//         modalEmailText.innerHTML = btnEl.getAttribute("data-popup-text");
//       } else {
//         modalEmailText.innerHTML = btnEl.closest(".block_license_card").querySelector(".text_transfer_license_permanently").innerText;
//       }
//     } else if (btnEl.classList.contains("temporary_transfer_type")) {
//       btnType = "temporary";
//       if(btnEl.getAttribute("data-popup-text") !== null) {
//         modalEmailText.innerHTML = btnEl.getAttribute("data-popup-text");
//       } else {
//         modalEmailText.innerHTML = btnEl.closest(".block_license_card").querySelector(".text_transfer_license_temporary").innerText;
//       }
//     }
//     if(dataShowEmail === "true") {

//       inputEmail.style.display = "block";
//     } else {
//       inputEmail.style.display = "none";
//     }
//     emailModalWindow.style.display = "block";
//     setListenerSend(
//       btnType,
//       dataKey,
//       btnEl.closest(".block_license_card"),
//       dataShowEmail
//     );
//   }
// })

function removeMsgModal() {
  btnCancelEmailModal.innerHTML = "cancel";
  document.querySelector(".wrapper_email_sent_btn").classList.remove("hide");
  document.querySelector(".modal_email").classList.remove("hide");
  document.querySelector(".block_modal_email_text").classList.remove("hide");
  blockMsgEmailModal.classList.remove("show_msg");
}
closeEmailModal &&
  closeEmailModal.addEventListener("click", function () {
    emailModalWindow.style.display = "none";
    unlockScroll();
    removeMsgModal();
  });
btnCancelEmailModal &&
  btnCancelEmailModal.addEventListener("click", function () {
    emailModalWindow.style.display = "none";
    unlockScroll();
    removeMsgModal();
  });
window.addEventListener("click", function (event) {
  if (event.target == emailModalWindow) {
    emailModalWindow.style.display = "none";
    unlockScroll();
    removeMsgModal();
  }
});
closeModalESC(emailModalWindow);

function deleteListenersSentBtn(className) {
  let oldElement = document.querySelector(className);
  let newElement = oldElement.cloneNode(true);
  oldElement.parentNode.replaceChild(newElement, oldElement);
}
function setListenerSend(btnType, dataKey, card, showEmailInput) {
  deleteListenersSentBtn(".wrapper_email_sent_btn");
  console.log("showEmailInput", showEmailInput)
  let params = "";
  document
    .querySelector(".modal_email_btn_send")
    .addEventListener("click", function () {
      if (btnType === "find_license") {
        if (checkInputsFindmyv4()) {
          params = setParamsForRequest(
            btnType,
            inputEmail.value,
            inputKey.value,
            dataKey
          );
          console.log(params);
          requestEmailModal(findV4_btn_url, params);
        }
      } else {
        let params;
        if (!validateEmail(inputEmail)) {
          if(showEmailInput === "true") {
            inputEmailMsg.classList.add("show_msg");
          } else {
            params = setParamsForRequest(
              btnType,
              "",
              inputKey.value,
              dataKey
            );
          }
        } else {
          inputEmailMsg.classList.remove("show_msg");
          params = setParamsForRequest(
            btnType,
            inputEmail.value,
            inputKey.value,
            dataKey
          );
         
        }
        if (btnType === "permanently") {
          requestEmailModal(parmanently_btn_url, params, card);
        }
        if (btnType === "temporary") {
          requestEmailModal(temporary_btn_url, params, card);
        }
      }
    });
}
function setDisableBtn(card, btnClassName) {
  let btnsCard = card.querySelectorAll(btnClassName);
  if (btnsCard.length > 0) {
    for (let btn of btnsCard) {
      btn.classList.add("disable");
    }
  }
}
function setAvailableBtn(card, btnClassName) {
  let btnsCard = card.querySelectorAll(btnClassName);
  if (btnsCard.length > 0) {
    for (let btn of btnsCard) {
      btn.classList.remove("disable");
    }
  }
}
function checkInputsFindmyv4() {
  if (
    (inputEmail.value === "" && inputKey.value === "") ||
    (inputEmail.value !== "" && inputKey.value !== "")
  ) {
    blockMsgEmailModal.innerHTML = textCheckInputs.innerText;
    inputEmailMsg.classList.remove("show_msg");
    inputKeyMsg.classList.remove("show_msg");
    blockMsgEmailModal.classList.add("error");
    blockMsgEmailModal.classList.add("show_msg");
  } else {
    blockMsgEmailModal.classList.remove("show_msg");
    if (inputEmail.value !== "") {
      if (!validateEmail(inputEmail)) {
        inputKeyMsg.classList.remove("show_msg");
        inputEmailMsg.classList.add("show_msg");
        return false;
      } else {
        inputEmailMsg.classList.remove("show_msg");
        return true;
      }
    } else {
      if (!validateLicenseKey(inputKey.value)) {
        inputEmailMsg.classList.remove("show_msg");
        inputKeyMsg.classList.add("show_msg");
        return false;
      } else {
        inputKeyMsg.classList.remove("show_msg");
        return true;
      }
    }
  }
}

function validateLicenseKey(key) {
  if (key.length == 27) {
    return true;
  } else {
    return false;
  }
}
function setParamsForRequest(btnType, email, key, dataKey) {
  if (btnType === "find_license") {
    return `FindV4[email]=` + email + `&FindV4[key]=` + key;
  } else {
    return (
      `email=` +
      email +
      `&key=` +
      dataKey
    );
  }
}


// REQUEST FOR FINDV4/SIMPLE TRANSFER/TEMPORARY TRANSFER
function requestEmailModal(urlRequest, paramsRequest, card) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  // const url = "/serialkey/transfer/test";
  const params = paramsRequest + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("transfer or findV4 response", request.responseText);
        let response = JSON.parse(request.responseText);

        
        if (response.status === "ok") {
          btnCancelEmailModal.innerHTML = "ok";
          document.querySelector(".wrapper_email_sent_btn").classList.add("hide");
          document.querySelector(".modal_email").classList.add("hide");
          document.querySelector(".block_modal_email_text").classList.add("hide");
          blockMsgEmailModal.classList.remove("error");
          blockMsgEmailModal.innerText = response.message;
          blockMsgEmailModal.classList.add("show_msg");

          if (response["transfer-type"] === "permanent") {
            if (response.delete) {
              card.remove();
            } else {
              settingsBtnCard(card, response.buttons);
              for (let msgBlock of card.querySelectorAll(".license_upgrade_msg")) {
                msgBlock.innerText = response.message;
              }
            }
          }
          if (response["transfer-type"] === "temporary") {
            if (response.email === "") {
              settingsBtnCard(card, response.buttons);
              for (let msgBlock of card.querySelectorAll(".license_upgrade_msg")) {
                msgBlock.innerText = response.message;
              }
            } else {
              changeTemporaryToRevoke(card, response.email, response.name);
              settingsBtnCard(card, response.buttons)
            }
          }
        }
        if (response.status === "error") {
          showMsg("msg_for_email_modal", response.message);
        }
      }
    }
  });
  request.send(params);
}
function changeTemporaryToRevoke(card, email, name) {
  for (let temporaryBtn of card.querySelectorAll(".temporary_transfer_type")) {
    // alert(temporaryBtn)
    let blockEl = document.createElement("div");
    blockEl.classList.add("block_btn_name_email");
    let insertEl = `
    <div class="transfer_btn_revoke" data-key="` + temporaryBtn.getAttribute("data-key") + `" data-email="` + email + `">
        <div class="text">revoke from</div>
      </div>
      <div class="transfer_email">` + email + `</div>
      <div class="transfer_name">` + name + `</div>
    `;
    blockEl.innerHTML = insertEl;
    temporaryBtn.parentNode.replaceChild(blockEl, temporaryBtn);
    removePermanentBtn(card);
  }
}

function removePermanentBtn(card) {
  let arrBtns = card.querySelectorAll(".simple_transfer_type");
  for (let btn of arrBtns) {
    btn.remove();
  }
}

try {
  let keyMask = IMask(document.getElementById("key_modal_input"), {
    mask: "******-******-******-******",
  });
} catch (error) { }
// END MODAL WINDOW WITH EMAIL

// MODAL WINDOW WITH BTN FIND MY V4 LICENSE
// modal_v4_licenses
const f4LicenseModal = document.querySelector("#modalV4License");
const closeF4LicenseModal = document.querySelector(".close_modal_v4_license");

// open modal find v4 license
body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".modal_v4_licenses");
  if (btnEl) {
    lockScroll();
    f4LicenseModal.style.display = "block";
  }
})

// close modal find v4 license
closeF4LicenseModal &&
closeF4LicenseModal.addEventListener("click", function () {
    f4LicenseModal.style.display = "none";
    unlockScroll();
  });
window.addEventListener("click", function (event) {
  if (event.target == f4LicenseModal) {
    f4LicenseModal.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(f4LicenseModal);
// END MODAL WINDOW WITH BTN FIND MY V4 LICENSE

// MODAL TRANSFER(EMAIL INPUT)
const transferModal = document.querySelector(".container_modal_transfer");

// get content transfer modal
body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".transfer_btn");
  if (btnEl) {
    const url = btnEl.getAttribute("data-url");
    const key = btnEl.getAttribute("data-key");
    getContentTransferModal(url, key);
  }
})

// get content for modal link extra modules
function getContentTransferModal(urlRequest, key) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "key=" + key + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        setContentTransferModal(request.responseText);
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

// set content for transfer modal 
function setContentTransferModal(content) {
  transferModal.innerHTML = content;
  lockScroll();
  transferModal.style.display = "block";
}

// btn confirm transfer listener
transferModal && transferModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".modal_transfer_btn_send");
  if (btnEl) {
    checkEmailTransferModal()
  }
})

// check input in transfer modal
function checkEmailTransferModal() {
  const emailEl = transferModal.querySelector("#transfer_modal_input");
  const errorMsgEl = transferModal.querySelector("#transfer_modal_msg");

  if (!validateEmail(emailEl)) {
    errorMsgEl.classList.add("show_msg");
  } else {
    errorMsgEl.classList.remove("show_msg");

    const url = transferModal.querySelector(".modal_transfer_btn_send").getAttribute("data-url");
    const key = transferModal.querySelector(".modal_transfer_btn_send").getAttribute("data-key");
    const email = emailEl.value;

    transferAttachToShopCart(url, key, email);
  }
}

function transferAttachToShopCart(url, key, email) {
  const request = new XMLHttpRequest();

  const params = "key=" + key + "&email=" + email + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4 && request.status === 200) {
      let response = JSON.parse(request.responseText);
      if (response.status === "ok") {

        response.cards.forEach(card => {
          setDataCardsFromResponse(card);
        });
      }
      // if (response.status === "error") {
      //   showAlert(response.message, true);
      // }
      if (response.status === "error404") {
        window.location.href = response.url;
      }

      unlockScroll();
      transferModal.style.display = "none";
    }
  });
  request.send(params);
}

// set html to card after request
export function setDataCardsFromResponse(card) {
  const allCardsEl = document.querySelectorAll(".block_license_card");

  allCardsEl.forEach(cardEl => {
      if(cardEl.getAttribute("data-card") === card.id.toString()) {
        if(card.remove) {
          cardEl.remove();
        } else {
          cardEl.outerHTML = card.html;
        }
      }
    });
}


// close transfer modal
transferModal && transferModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".close_modal_email");
  if (btnEl) {
    transferModal.style.display = "none";
    unlockScroll();
  }
})

transferModal && transferModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".modal_transfer_btn_cancel");
  if (btnEl) {
    transferModal.style.display = "none";
    unlockScroll();
  }
})

window.addEventListener("click", function (event) {
  if (event.target == transferModal) {
    transferModal.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(transferModal);

// END MODAL TRANSFER(EMAIL INPUT)

// REQUEST REVOKE FROM BTN
function contentModalRevoke(email, key, card) {
  delListenersFromBtn();
  let text = document.querySelector("#text_revoke").innerText;
  modalProfileText.innerText = text.trim() + " " + email + "?";
  document
    .querySelector(".modal_profile_btn_ok")
    .addEventListener("click", () => {
      requestRevokeFrom(email, key, card);
    });
  modalWindow.style.display = "block";
  lockScroll();
}

document.querySelector("#licenses_content"), addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".transfer_btn_revoke");
  if (btnEl) {
    let email = btnEl.getAttribute("data-email");
    let key = btnEl.getAttribute("data-key");
    contentModalRevoke(email, key, btnEl.closest(".block_license_card"));
  }
})

function setTemporaryTransferBtn(key) {
  return `
  <div
  class="transfer_btn temporary_transfer_type"
  data-key="` + key + `"
  data-url="` + temporary_btn_url + `"
  >
  <svg
    class="icon"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="198.43px"
    height="170.08px"
    viewBox="0 0 198.43 170.08"
    enable-background="new 0 0 198.43 170.08"
    xml:space="preserve"
  >
    <g>
      <polygon
        class="icon_fill"
        fill="#00FFE4"
        points="8,86.04 62.716,85.489 47.551,69.64 52.83,64.591 76.034,88.841 52.83,113.094 47.551,108.05 
   62.13,92.811 8.058,93.356 8,86.04 	"
      />
      <path
        class="icon_fill"
        fill="#00FEE2"
        d="M142.906,44.916c11.799,0.794,22.413,5.906,30.273,13.767c8.569,8.568,13.878,20.415,13.878,33.498
   c0,13.074-5.309,24.923-13.878,33.492s-20.417,13.878-33.494,13.878c-13.08,0-24.929-5.309-33.498-13.878
   c-8.568-8.569-13.876-20.418-13.876-33.492c0-13.083,5.309-24.929,13.876-33.498c7.861-7.861,18.479-12.973,30.276-13.767V40.01
   h-9.274c-1.976,0-3.581-1.604-3.581-3.581c0-1.975,1.605-3.579,3.581-3.579h24.991c1.977,0,3.578,1.604,3.578,3.579
   c0,1.977-1.602,3.581-3.578,3.581h-9.274V44.916L142.906,44.916z M102.307,44.895c1.373-1.41,3.639-1.442,5.048-0.071
   c1.411,1.371,1.442,3.637,0.072,5.047L96.697,60.855c-1.373,1.41-3.638,1.442-5.048,0.071c-1.411-1.37-1.443-3.636-0.072-5.046
   L102.307,44.895L102.307,44.895z M171.938,49.87c-1.369-1.41-1.339-3.676,0.073-5.047c1.409-1.371,3.675-1.338,5.047,0.071
   l10.731,10.986c1.369,1.41,1.339,3.676-0.073,5.046c-1.41,1.371-3.675,1.339-5.047-0.071L171.938,49.87L171.938,49.87z
    M136.683,71.127c0-1.975,1.603-3.579,3.578-3.579c1.975,0,3.58,1.604,3.58,3.579v18.052h17.182c1.975,0,3.576,1.603,3.576,3.575
   c0,1.975-1.602,3.583-3.576,3.583h-20.762c-1.976,0-3.578-1.608-3.578-3.583V71.127L136.683,71.127z M167.359,64.503
   c-7.078-7.081-16.868-11.465-27.674-11.465c-10.808,0-20.598,4.385-27.678,11.465c-7.08,7.08-11.464,16.869-11.464,27.678
   c0,10.803,4.384,20.592,11.464,27.672s16.87,11.467,27.678,11.467c10.806,0,20.596-4.387,27.674-11.467
   c7.08-7.08,11.467-16.869,11.467-27.672C178.826,81.372,174.439,71.583,167.359,64.503L167.359,64.503z"
      />
    </g>
  </svg>
  <div class="text">temporary license permanenrly</div>
  </div>`
}
function setSimpleTransferBtn(key) {
  return `
  <div class="transfer_btn simple_transfer_type" data-key="` + key + `" data-url="` + parmanently_btn_url + `">
            <svg class="icon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="198.43px" height="170.08px" viewBox="0 0 198.43 170.08" enable-background="new 0 0 198.43 170.08" xml:space="preserve">
              <g>
                <path class="icon_fill" fill="#00FFE4" d="M79.946,137.906c5.512-9.118,13.546-16.726,23.217-22c9.314-5.081,20.128-7.991,31.639-7.991
  c12.137,0,23.49,3.233,33.125,8.825c9.984,5.796,18.118,14.139,23.364,24.063l-7.032,3.709
  c-4.545-8.602-11.62-15.847-20.313-20.897c-8.445-4.904-18.434-7.734-29.144-7.734c-10.177,0-19.689,2.551-27.841,6.997
  c-8.415,4.586-15.408,11.211-20.201,19.134L79.946,137.906L79.946,137.906z M135.563,30.08c9.457,0,18.021,3.835,24.221,10.033
  c6.197,6.199,10.033,14.763,10.033,24.22c0,9.458-3.836,18.021-10.033,24.216c-6.2,6.204-14.764,10.034-24.221,10.034
  s-18.021-3.83-24.218-10.034c-6.2-6.195-10.034-14.758-10.034-24.216c0-9.457,3.834-18.021,10.034-24.22
  C117.543,33.916,126.106,30.08,135.563,30.08L135.563,30.08z M154.151,45.745c-4.754-4.754-11.329-7.697-18.588-7.697
  s-13.83,2.943-18.588,7.697c-4.755,4.757-7.698,11.33-7.698,18.588c0,7.259,2.943,13.832,7.698,18.586
  c4.758,4.757,11.329,7.698,18.588,7.698s13.834-2.94,18.588-7.698c4.754-4.754,7.698-11.328,7.698-18.586
  C161.85,57.075,158.905,50.501,154.151,45.745L154.151,45.745z"></path>
                <polygon class="icon_fill" fill="#00FFE4" points="6.131,86.229 65.479,85.629 49.031,68.439 54.757,62.963 79.926,89.27 54.757,115.575 
  49.031,110.099 64.844,93.575 6.193,94.167 6.131,86.229 	"></polygon>
              </g>
            </svg>
            <div class="text">transfer license permanenrly</div>
          </div>
  `
}

function changeRevokeToTransfer(card, key) {
  let temporaryBtn = setTemporaryTransferBtn(key);
  let parmanentlyBtm = setSimpleTransferBtn(key)
  let desktopBtnsBlock = card.querySelector(".block_transfer_btn");
  desktopBtnsBlock.innerHTML = temporaryBtn + parmanentlyBtm;

  let mobileBtnsBlock = card.querySelector(".block_bottom_license_card");
  mobileBtnsBlock.innerHTML = temporaryBtn + parmanentlyBtm;
}

function requestRevokeFrom(email, key, card) {
  const request = new XMLHttpRequest();
  const url = revoke_url;
  const params =
    "email=" +
    email +
    "&key=" +
    key +
    "&_csrf=" +
    jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("change request response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          changeRevokeToTransfer(card, key);
          settingsBtnCard(card, response.buttons);
          modalProfileText.style.display = "none";
          document.querySelector(".modal_profile_btn_ok").style.display = "none";
          document.querySelector("#modal_window_msg").innerText = response.message;
          btnProfileModalCancel.innerText = "ok";
          document.querySelector("#modal_window_msg").style.display = "block";
  
        }
        if (response.status === "error") {
          let responseErrorsMsg = createErrorsMsg(response.errors);
          showMsg("modal_window_msg", responseErrorsMsg);
          console.log("revoke response", responseErrorsMsg);
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
// END REQUEST REVOKE FROM BTN

// BTN DOWNLOAD PRODUCT

body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".download_product");
  if (btnEl) {
    removeAllActiveClass();
    const url = btnEl.getAttribute("data-url");
    const osID = btnEl.getAttribute("data-os");
    const productID = btnEl.getAttribute("data-product");
    getDownloadProduct(url, osID, productID);
    document.querySelector("#download_content").classList.add("active_cabinet_content");
  }
})

function removeAllActiveClass() {
  removeClassInElements(".container_cabinet_content", "active_cabinet_content");
  removeClassInElements(".nav_cabinet_item", "active_border_bottom");
}

function getDownloadProduct(urlRequest, os, product) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "os=" + os + "&product=" + product + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          setDowloadTable(response.table);
          setDowloadSelect(response.select);
          document
            .querySelector("#download_content")
            .classList.add("active_cabinet_content");
        }
        if (response.status === "error") {
          window.location.href = "/404";
        }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

function setDowloadTable(table) {
  let downloadProfileTable = document.querySelector(".table_versions");
  downloadProfileTable.content = "";
  downloadProfileTable.innerHTML = table;
}

function setDowloadSelect(arrSelects) {
  let selectInput = document.querySelector("#profile_download_select");
  let newElement = selectInput.cloneNode(true);
  selectInput.parentNode.replaceChild(newElement, selectInput);
  selectInput = document.querySelector("#profile_download_select");
  let selectItemText = "";
  if (arrSelects.length > 0) {
    selectInput.querySelector(".select__body").innerHTML = "";
    selectInput.querySelector(".select__current").innerHTML = "";
    for (let item of arrSelects) {
      selectItemText =
        `<div class="select__item_profile profile" data-os="` +
        item.os_id +
        `" data-product-id="` +
        item.product_id +
        `" data-url="` +
        item.data_url +
        `">
      ` +
        item.title +
        `
    </div>`;
      selectInput
        .querySelector(".select__body")
        .insertAdjacentHTML("beforeend", selectItemText);
      if (item.current) {
        selectInput.querySelector(".select__current").innerText = item.title;
        selectInput
          .querySelector(".select__current")
          .setAttribute("data-url", item.data_url);
        selectInput
          .querySelector(".select__current")
          .setAttribute("data-os", item.os_id);
        selectInput
          .querySelector(".select__current")
          .setAttribute("data-product-id", item.product_id);
      }
    }
    selectDownloadProfile();
  }
}

function selectDownloadProfile() {
  let selectHeader = document.querySelectorAll(".select__header_profile");
  let selectItem = document.querySelectorAll(".select__item_profile");

  selectHeader.forEach((item) => {
    item.addEventListener("click", function () {
      closeAllSelect(this.parentElement);
      this.parentElement.classList.toggle("active");
    });
  });

  selectItem.forEach((item) => {
    item.addEventListener("click", function () {
      let dataUrl = this.getAttribute("data-url");
      let dataOsID = this.getAttribute("data-os");
      let dataProductID = this.getAttribute("data-product-id");
      let text = this.innerText,
        select = this.closest(".select"),
        currentText = select.querySelector(".select__current");
      currentText.innerText = text;
      currentText.setAttribute("data-url", dataUrl);
      currentText.setAttribute("data-os", dataOsID);
      currentText.setAttribute("data-product-id", dataProductID);
      select.classList.remove("active");
      getDownloadProduct(dataUrl, dataOsID, dataProductID);
    });
  });
}

// HIDE MESSAGE TEXT ON LICENSES TAB
// hide msg
document.querySelector("body").addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".btn_close_more_info_msg");
  if (btnEl) {
    let blockMsg = elEvent.closest(".container_licenses_top_msg");
    blockMsg.classList.remove("open");
  }
})
// btn buy in msg
document.querySelector("body").addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".licenses_msg_btn_buy");
  if (btnEl) {
    let blockMsg = elEvent.closest(".container_licenses_top_msg");
    let url = btnEl.getAttribute("data-url");
    let key = btnEl.getAttribute("data-key");
    buyFromLicensesMsg(url, key, blockMsg);
  }
})
function buyFromLicensesMsg(url, key, blockMsg) {
  const request = new XMLHttpRequest();
  const params = "&key=" + key + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        blockMsg.classList.remove("open");
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}


// btn don't show anymore

document.querySelector("body").addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".licenses_msg_dont_show");
  if (btnEl) {
    let url = btnEl.getAttribute("data-url");
    let id = btnEl.getAttribute("data-id");
    if (id !== null) {
      removeLicensesMsg(url, id, btnEl);
    } else {
      removeLicensesMsg(url, "", btnEl);
    }
  }
})
function removeLicensesMsg(urlRequest, id, btn) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "&id=" + id + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let blockMsg = btn.closest(".container_licenses_top_msg");
        blockMsg.classList.remove("open");
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
// END HIDE MESSAGE TEXT ON LICENSES TAB

// MODAL CABINET UPGRADE
let cabinetUpgradeModal = document.getElementById("cabinet_upgrade_modal");
let closeCabinetUpgrade = document.querySelector(
  ".close_modal_cabinet_upgrade"
);
let cabinetUpgradeSimple = document.querySelector(
  ".block_cabinet_upgrade_simple"
);
let cabinetUpgradeFloating = document.querySelector(
  ".block_cabinet_upgrade_floating"
);
let cabinetUpgradeAddCart = document.querySelector(".cabinet_upgrade_btn_add");
let cabinetUpgradeCancel = document.querySelector(
  ".cabinet_upgrade_btn_cancel"
);
let selectedCabinetUserType = document.querySelector(
  "#selected_type_user_upgrade"
);

function cabinetUpgradeAdd(urlRequest, arrKeys, card) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "&data=" + arrKeys + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader(
    "Content-type",
    "application/x-www-form-urlencoded"
  );
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          document.querySelector(".basket_dot").classList.add("active");
          cabinetUpgradeModal.style.display = "none";
          unlockScroll();

          settingsBtnCard(card, response.buttons);

          showAlert(response.message, false, response.isFree);
  
          for (let msgBlock of card.querySelectorAll(".license_upgrade_msg")) {
            msgBlock.innerText = response["message_cabinet_profile"];
          }
        }
        if (response.status === "error") {
          cabinetUpgradeModal.style.display = "none";
          unlockScroll();
        }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
    cabinetUpgradeModal.style.display = "none";
    unlockScroll();
  });
  request.send(params);
}

function settingsBtnCard(card, settingBtns) {
  // setting ".simple_upgrade"
  if(settingBtns.upgrade.show) {
    setShowBtn(card, ".simple_upgrade");
    if(settingBtns.upgrade.disable) {
      setDisableBtn(card, ".simple_upgrade")
    } else {
      setAvailableBtn(card, ".simple_upgrade")
    }
  } else {
    setHideBtn(card, ".simple_upgrade");
  }

  // setting ".floating_upgrade"
  if(settingBtns.upgrade_to_floating.show) {
    setShowBtn(card, ".floating_upgrade");
    if(settingBtns.upgrade_to_floating.disable) {
      setDisableBtn(card, ".floating_upgrade")
    } else {
      setAvailableBtn(card, ".floating_upgrade")
    }
  } else {
    setHideBtn(card, ".floating_upgrade");
  }

  // setting ".simple_transfer_type"
  if(settingBtns.transfer_permanent.show) {
    setShowBtn(card, ".simple_transfer_type");
    if(settingBtns.transfer_permanent.disable) {
      setDisableBtn(card, ".simple_transfer_type")
    } else {
      setAvailableBtn(card, ".simple_transfer_type")
    }
  } else {
    setHideBtn(card, ".simple_transfer_type");
  }

  // setting ".temporary_transfer_type"
  if(settingBtns.transfer_temporary.show) {
    setShowBtn(card, ".temporary_transfer_type");
    if(settingBtns.transfer_temporary.disable) {
      setDisableBtn(card, ".temporary_transfer_type")
    } else {
      setAvailableBtn(card, ".temporary_transfer_type")
    }
  } else {
    setHideBtn(card, ".temporary_transfer_type");
  }

  // setting ".block_btn_name_email" REVOKE block
  if(settingBtns.revoke.show) {
    setShowBtn(card, ".block_btn_name_email");
    if(settingBtns.revoke.disable) {
      setDisableBtn(card, ".block_btn_name_email")
    } else {
      setAvailableBtn(card, ".block_btn_name_email")
    }
  } else {
    setHideBtn(card, ".block_btn_name_email");
  }
}

// hide btns in card
function setHideBtn(card, btnClassName) {
  let btnsCard = card.querySelectorAll(btnClassName);
  if (btnsCard.length > 0) {
    for (let btn of btnsCard) {
      btn.classList.add("hide");
    }
  }
}
// show btns in card
function setShowBtn(card, btnClassName) {
  let btnsCard = card.querySelectorAll(btnClassName);
  if (btnsCard.length > 0) {
    for (let btn of btnsCard) {
      btn.classList.remove("hide");
    }
  }
}

function listenerUpgradeAddCart(card, typeUpgrade) {
  deleteListenersSentBtn(".wrapper_cabinet_upgrade_btn");
  let cabinetUpgradeAddCart = document.querySelector(".cabinet_upgrade_btn_add")
  cabinetUpgradeAddCart &&
    cabinetUpgradeAddCart.addEventListener("click", (event) => {
      if(document.querySelector("#selected_type_user_upgrade").innerText === "" && typeUpgrade === "simple_upgrade") {
        document.querySelector("#cabinet_upgrade_modal .error_msg_cabinet_upgrade").style.display = "block";
      } else {
        cabinetUpgradeAdd(
          event.target.getAttribute("data-url"),
          event.target.getAttribute("data-key"),
          card
        );
      }
    });
}


document.querySelector("#licenses_content") &&
  document
    .querySelector("#licenses_content")
    .addEventListener("click", (event) => {
      let elEvent = event.target;
      let btnEl = elEvent.closest(".cabinet_upgrade");
      let cabinetUpgradeAddCart = document.querySelector(".cabinet_upgrade_btn_add");
      if (btnEl) {
        document.querySelector("#cabinet_upgrade_modal .error_msg_cabinet_upgrade").style.display = "none";
        document.querySelector("#cabinet_upgrade_modal #error_msg_cabinet_upgrade_disabled").style.display = "none";
        document.querySelector("#cabinet_upgrade_modal #error_msg_cabinet_upgrade_disabled_expired").style.display = "none";
        if (btnEl.classList.contains("simple_upgrade")) {
          document.querySelector("#cabinet_upgrade_modal .select__body.profile").innerHTML = "";
          document.querySelector("#selected_type_user_upgrade").innerHTML = "";
          document.querySelector("#cabinet_upgrade_modal .price").style.display = "none";
          // for remove all listeners
          let old_element = document.querySelector("#cabinet_upgrade_modal .profile_select");
          let new_element = old_element.cloneNode(true);
          old_element.parentNode.replaceChild(new_element, old_element);
          // Upgrade now disabled but will be enabled in future
          if (btnEl.classList.contains("disable")) {
            if (btnEl.classList.contains("updates_expired")) {
              document.querySelector("#cabinet_upgrade_modal #error_msg_cabinet_upgrade_disabled_expired").style.display = "block";
            }else {
              document.querySelector("#cabinet_upgrade_modal #error_msg_cabinet_upgrade_disabled").style.display = "block";
            }

            document.querySelector("#cabinet_upgrade_modal .block_cabinet_upgrade_simple .text").innerText = '';
            document.querySelector("#cabinet_upgrade_modal .price .price_title").innerText = '';
            // Hide the form input section (dropdown)
            document.querySelector("#cabinet_upgrade_modal .form_input").style.display = "none";
            // Hide the buttons (add to cart, cancel)
            document.querySelector("#cabinet_upgrade_modal .block_cabinet_upgrade_btns").style.display = "none";
          }else{
            let objData = JSON.parse(btnEl.getAttribute("data-options"));
            createOptionsUpgradeModal(objData);
            document.querySelector("#cabinet_upgrade_modal .block_cabinet_upgrade_simple .text").innerText = objData.text_header;
            document.querySelector("#cabinet_upgrade_modal .price .price_title").innerText = objData.text_price;
            // Show the form input section (dropdown)
            document.querySelector("#cabinet_upgrade_modal .form_input").style.display = "block";
            document.querySelector("#cabinet_upgrade_modal .block_cabinet_upgrade_btns").style.removeProperty("display");
            cabinetUpgradeSimple.classList.add("show");
            cabinetUpgradeFloating.classList.remove("show");
            listenerUpgradeAddCart(elEvent.closest(".block_license_card"), "simple_upgrade");
          }
        } else {
          cabinetUpgradeAddCart.setAttribute(
            "data-key",
            btnEl.getAttribute("data-key")
          );
          cabinetUpgradeAddCart.setAttribute(
            "data-url",
            btnEl.getAttribute("data-url")
          );
          
          getDataFloatingUpgrade(btnEl.getAttribute("data-url-price"), btnEl.getAttribute("data-key"));
          cabinetUpgradeSimple.classList.remove("show");
          cabinetUpgradeFloating.classList.add("show");
          listenerUpgradeAddCart(elEvent.closest(".block_license_card"), "floating_upgrade");
        }
        lockScroll();
        cabinetUpgradeModal.style.display = "block";
      }
    });

// creat options for select in upgrade modal (simple_upgrade)
function createOptionsUpgradeModal(data) {
  let blockOptions = document.querySelector("#cabinet_upgrade_modal .select__body.profile");
  let optionHTML = "";
  for (let option of data.options) {
    optionHTML = `<div class="select__item_cabinet_upgrade profile" data-url="${option.cart_url}" data-url-price="${option.reprice_url}" data-key="${option.key}"> ${option.text} </div>`;
    blockOptions.insertAdjacentHTML( 'beforeend', optionHTML );
  }
  selectCabinetUpgrade();
}

let priceUpgradeUser = "";
let priceSaleUpgradeUser = "";

// get price for simple_upgrade in upgrade modal 
function getPriceForUpdate(urlRequest, key) {
  priceUpgradeUser = priceSaleUpgradeUser = "";
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "&data=" + key + "&_csrf=" + jst_csrf;
  request.open("POST", url, false);
  request.setRequestHeader(
    "Content-type",
    "application/x-www-form-urlencoded"
  );
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          document.querySelector("#cabinet_upgrade_modal .price").style.display = "flex";
          document.querySelector("#cabinet_upgrade_modal .error_msg_cabinet_upgrade").style.display = "none";

          document.querySelector(".container_modal_cabinet_upgrade .price_title").innerHTML = response.popupText;
          document.querySelector(".container_modal_cabinet_upgrade .cabinet_upgrade_btn_add").innerHTML = response.btnText;
          
          if(response.isFree) {
            document.querySelector(".container_modal_cabinet_upgrade .wrapper_prices").style.display = "none";
          } else {
            document.querySelector(".container_modal_cabinet_upgrade .wrapper_prices").style.display = "flex";
            priceUpgradeUser = response.price;
            priceSaleUpgradeUser = response.discount_price;
          }
        }
        if (response.status === "error") {
          window.location.href = "/404";
        }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

// get data for floating_upgrade in upgrade modal 
function getDataFloatingUpgrade(urlRequest, key) {
  priceUpgradeUser = priceSaleUpgradeUser = "";
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "&data=" + key + "&_csrf=" + jst_csrf;
  request.open("POST", url, false);
  request.setRequestHeader(
    "Content-type",
    "application/x-www-form-urlencoded"
  );
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          document.querySelector(".block_cabinet_upgrade_floating .text").innerHTML = response.text;
          if (response.discount_price !== false) {
            document.querySelector("#floating_upgrade_sale_price").style.display = "flex";
            document.querySelector("#floating_upgrade_sale_price").innerHTML = `<span>&euro;</span>
            <div>${response.discount_price}</div>
            <span class="price_star big">*</span>`;
    
            document.querySelector("#floating_upgrade_price").classList.add("price_old");
            document.querySelector("#floating_upgrade_price").innerHTML = `<span>&euro;</span>
            <div>${response.price}</div>`;
          } else {
            document.querySelector("#floating_upgrade_sale_price").style.display = "none";
    
            document.querySelector("#floating_upgrade_price").classList.remove("price_old");
            document.querySelector("#floating_upgrade_price").innerHTML = `<span>&euro;</span>
            <div>${response.price}</div>
            <span class="price_star big">*</span>`;
          }
        }
        if (response.status === "error") {
          window.location.href = "/404";
        }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

closeCabinetUpgrade &&
  closeCabinetUpgrade.addEventListener("click", function () {
    cabinetUpgradeModal.style.display = "none";
    unlockScroll();
  });
cabinetUpgradeCancel &&
  cabinetUpgradeCancel.addEventListener("click", function () {
    cabinetUpgradeModal.style.display = "none";
    unlockScroll();
  });
window.addEventListener("click", function (event) {
  if (event.target == cabinetUpgradeModal) {
    cabinetUpgradeModal.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(cabinetUpgradeModal);

function selectCabinetUpgrade() {
  let selectHeader = document.querySelectorAll(
    ".select__header_cabinet_upgrade"
  );
  let selectItem = document.querySelectorAll(".select__item_cabinet_upgrade");

  selectHeader.forEach((item) => {
    item.addEventListener("click", function () {
      closeAllSelect(this.parentElement);
      this.parentElement.classList.toggle("active");
    });
  });

  selectItem.forEach((item) => {
    item.addEventListener("click", function () {
      let dataKey = this.getAttribute("data-key");
      let dataPriceUrl = this.getAttribute("data-url-price");
      let dataUrl = this.getAttribute("data-url");
      getPriceForUpdate(dataPriceUrl, dataKey);
      if (priceSaleUpgradeUser !== false) {
        document.querySelector("#simple_upgrade_sale_price").style.display = "flex";
        document.querySelector("#simple_upgrade_sale_price").innerHTML = `<span>&euro;</span>
        <div>${priceSaleUpgradeUser}</div>
        <span class="price_star big">*</span>`;

        document.querySelector("#simple_upgrade_price").classList.add("price_old");
        document.querySelector("#simple_upgrade_price").innerHTML = `<span>&euro;</span>
        <div>${priceUpgradeUser}</div>`;
      } else {
        document.querySelector("#simple_upgrade_sale_price").style.display = "none";

        document.querySelector("#simple_upgrade_price").classList.remove("price_old");
        document.querySelector("#simple_upgrade_price").innerHTML = `<span>&euro;</span>
        <div>${priceUpgradeUser}</div>
        <span class="price_star big">*</span>`;
      }
      
      let cabinetUpgradeAddCart = document.querySelector(".cabinet_upgrade_btn_add");
      let text = this.innerText,
        select = this.closest(".select"),
        currentText = select.querySelector(".select__current");
      currentText.innerText = text;
      cabinetUpgradeAddCart.setAttribute("data-key", dataKey);
      cabinetUpgradeAddCart.setAttribute("data-url", dataUrl);
      select.classList.remove("active");
    });
  });
}


// END MODAL CABINET UPGRADE

// MODAL RENT TO OWN
const modalRentToOWn = document.querySelector("#modalRentToOWn");
const closeModalRentToOwn = document.querySelector(".close_modal_rent_to_own");
const btnCancelRentToOwn = document.querySelector(".modal_rent_to_own_btn_cancel");
const btnComfirmRentToOwn = document.querySelector(".modal_rent_to_own_btn_send");

const blockTextTerminateRentToOwn = document.querySelector(".block_modal_rent_to_own_text.terminate_rent_to_own");
const blockSelectRentToOwn = document.querySelector(".form_input.modal_rent_to_own");
const labelSelectRentToOwn = document.querySelector("#label_rent_to_own");
const selectedOptionRentToOwn = document.querySelector("#selected_option_rent_to_own");
const errorMsgRentToOwnModal = document.querySelector(".error_modal_rent_to_own");

let currentRentToCart = null;

body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".btn_pause_rent_to_own");
  if (btnEl) {
    console.log("btn_pause_rent_to_own");
    lockScroll();
    document.querySelector("#msg_for_rent_to_own").style.display = "none";
    modalRentToOWn.style.display = "block";
  }
})

body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".btn_terminate_rent_to_own");
  if (btnEl) {
    if(btnEl.closest(".wrapper_license_card") !== null) {
      currentRentToCart = btnEl.closest(".wrapper_license_card");
    } else {
      currentRentToCart = btnEl.closest(".container_license_card_mob");
    }
    const dataUrl = btnEl.getAttribute("data-url");
    const dataKey = btnEl.getAttribute("data-key");
    btnComfirmRentToOwn.setAttribute("data-url", dataUrl);
    btnComfirmRentToOwn.setAttribute("data-key", dataKey);

    selectedOptionRentToOwn.innerText = "";
  
    blockTextTerminateRentToOwn.classList.remove("hide");
    blockTextTerminateRentToOwn.innerText = btnEl.getAttribute("data-text");
    blockSelectRentToOwn.classList.remove("hide");
    labelSelectRentToOwn.innerText = btnEl.getAttribute("data-text-label-select");
    errorMsgRentToOwnModal.classList.remove("show");

    lockScroll();
    document.querySelector("#msg_for_rent_to_own").style.display = "none";
    modalRentToOWn.style.display = "block";
  }
})

closeModalRentToOwn &&
closeModalRentToOwn.addEventListener("click", function () {
    modalRentToOWn.style.display = "none";
    unlockScroll();
  });
  btnCancelRentToOwn &&
  btnCancelRentToOwn.addEventListener("click", function () {
    modalRentToOWn.style.display = "none";
    unlockScroll();
  });
window.addEventListener("click", function (event) {
  if (event.target == modalRentToOWn) {
    modalRentToOWn.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(modalRentToOWn);
// confirm rent to own
btnComfirmRentToOwn &&
btnComfirmRentToOwn.addEventListener("click", function () {
  let dataUrl = this.getAttribute("data-url");
  let dataKey = this.getAttribute("data-key");
  if(selectedOptionRentToOwn.innerText === "") {
    errorMsgRentToOwnModal.classList.add("show");
  } else {
    errorMsgRentToOwnModal.classList.remove("show");
    let optionId = selectedOptionRentToOwn.getAttribute("data-id");
    requestRentToOwn(dataUrl, dataKey, optionId, currentRentToCart);
  }
});

// request confirm rent to own
function requestRentToOwn(urlRequest, key, reasonID, card) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "key=" + key + "&reason=" + reasonID + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          
          changeBtnOnMsgRentToOwn(card, response.message);
          if(card.querySelector(".rent_to_own_text") !== null) {
            card.querySelector(".rent_to_own_text").remove();
          } else {
            card.querySelector(".item_license").remove();
          }
          modalRentToOWn.style.display = "none";

          unlockScroll();
        }
        if (response.status === "error") {
          blockTextTerminateRentToOwn.classList.add("hide");
          blockSelectRentToOwn.classList.add("hide");
          document.querySelector("#msg_for_rent_to_own").innerText = response.message;
          document.querySelector("#msg_for_rent_to_own").style.display = "block";
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

// set message instead of button
function changeBtnOnMsgRentToOwn(card, message) {
  const confirmedBtnEl = card.querySelector(".block_btn_name_email");
  const successRespEl = `<div class="terminated_rent_to_own">${message}</div>`;
  confirmedBtnEl.outerHTML = successRespEl;
}
// END MODAL RENT TO OWN

// MODAL WINDOW FREE UPDATE
const freeUpdateModal = document.querySelector("#modalFreeUpdate");
const closeFreeUpdateModal = document.querySelector(".close_modal_free_update");
const cancelFreeUpdate = document.querySelector(".modal_free_upgrade_btn_cancel");
const confirmFreeUpdate = document.querySelector(".modal_free_upgrade_btn_ok");

let currentFreeUpdateCart;

// open modal free update
body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".free_update_modal");
  currentFreeUpdateCart = null;
  if (btnEl) {
    currentFreeUpdateCart = btnEl.closest(".block_license_card");
    let dataUrl = btnEl.getAttribute("data-url")
    let dataSerial = btnEl.getAttribute("data-serial");
    document.querySelector(".modal_free_upgrade_btn_ok").setAttribute("data-url", dataUrl);
    document.querySelector(".modal_free_upgrade_btn_ok").setAttribute("data-serial", dataSerial);
    document.querySelector(".block_modal_free_update_text").style.display = "block";
    document.querySelector("#msg_for_free_upgrade").style.display = "none";
    lockScroll();
    freeUpdateModal.style.display = "block";
  }
})
// close modal free update
cancelFreeUpdate &&
cancelFreeUpdate.addEventListener("click", function () {
  freeUpdateModal.style.display = "none";
  unlockScroll();
});
closeFreeUpdateModal &&
closeFreeUpdateModal.addEventListener("click", function () {
  freeUpdateModal.style.display = "none";
  unlockScroll();
});
window.addEventListener("click", function (event) {
  if (event.target == freeUpdateModal) {
    freeUpdateModal.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(freeUpdateModal);

// confirm free update
confirmFreeUpdate &&
confirmFreeUpdate.addEventListener("click", function () {
  let dataUrl = this.getAttribute("data-url");
  let dataSerial = this.getAttribute("data-serial");
  requestFreeUpdate(dataUrl, dataSerial, currentFreeUpdateCart);
});

// request confirm update
function requestFreeUpdate(urlRequest, serial, card) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "serial=" + serial + "&_csrf=" + jst_csrf;
  const wrapperCarts = document.querySelector(".wrapper_license_carts");
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          card.remove();
          wrapperCarts.insertAdjacentHTML( 'afterbegin', response.message );
          freeUpdateModal.style.display = "none";
          unlockScroll();
          document.querySelector("#licenses_content").scrollIntoView({block: "start", behavior: "smooth"});
        }
        if (response.status === "error") {
          document.querySelector(".block_modal_free_update_text").style.display = "none";
          document.querySelector("#msg_for_free_upgrade").innerText = response.message;
          document.querySelector("#msg_for_free_upgrade").style.display = "block";
          return false;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
// END MODAL WINDOW FREE UPDATE

// MODAL WINDOW PROFILE LINK
const profileLinkModal = document.querySelector("#modalProfileLink");
const closeProfileLinkModal = document.querySelector(".close_modal_profile_link");
const cancelProfileLink = document.querySelector(".modal_profile_link_btn_cancel");

// open modal profile link
body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".modal_profile_link");
  if (btnEl) {
    let dataProfileLink = btnEl.getAttribute("data-profile-link")
    document.querySelector(".block_modal_profile_link_text a").href = dataProfileLink;
    lockScroll();
    profileLinkModal.style.display = "block";
  }
})
// close modal profile link
cancelProfileLink &&
cancelProfileLink.addEventListener("click", function () {
  profileLinkModal.style.display = "none";
  unlockScroll();
});
closeProfileLinkModal &&
closeProfileLinkModal.addEventListener("click", function () {
  profileLinkModal.style.display = "none";
  unlockScroll();
});
window.addEventListener("click", function (event) {
  if (event.target == profileLinkModal) {
    profileLinkModal.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(profileLinkModal);
// END MODAL WINDOW PROFILE LINK
